import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 48,
    seconds: 34
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-bold text-slate-900" data-id="element-2">
      <div className="flex flex-col items-center" data-id="element-3">
        <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-slate-200 min-w-[60px] text-center" data-id="element-4">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <span className="text-xs text-slate-500 mt-1 font-medium uppercase tracking-wider" data-id="element-5">
          Horas
        </span>
      </div>
      <span className="text-slate-400 -mt-5" data-id="element-6">:</span>
      <div className="flex flex-col items-center" data-id="element-7">
        <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-slate-200 min-w-[60px] text-center" data-id="element-8">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <span className="text-xs text-slate-500 mt-1 font-medium uppercase tracking-wider" data-id="element-9">
          Min
        </span>
      </div>
      <span className="text-slate-400 -mt-5" data-id="element-10">:</span>
      <div className="flex flex-col items-center" data-id="element-11">
        <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-slate-200 min-w-[60px] text-center" data-id="element-12">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <span className="text-xs text-slate-500 mt-1 font-medium uppercase tracking-wider" data-id="element-13">
          Seg
        </span>
      </div>
    </div>;
}